// header solid on scroll
  const header = document.getElementById('siteHeader');
  window.addEventListener('scroll', () => {
    if(window.scrollY > 40){ header.classList.add('solid'); }
    else{ header.classList.remove('solid'); }
  });

  // scroll reveal
  const revealEls = document.querySelectorAll('.reveal');
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  },{threshold:0.1, rootMargin:"0px 0px -60px 0px"});
  revealEls.forEach(el=>io.observe(el));

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item=>{
    item.querySelector('.faq-q').addEventListener('click', ()=>{
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(o=>o.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  // cart badge — shared across all pages
  window.kickfitUpdateCartBadge = function(){
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('has-items', cart.item_count > 0);
      });
    });
  };

  // mobile hamburger menu
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var mobileNavPanel = document.getElementById('mobileNavPanel');
  if(hamburgerBtn && mobileNavPanel){
    hamburgerBtn.addEventListener('click', function(){
      var isOpen = hamburgerBtn.classList.toggle('open');
      mobileNavPanel.classList.toggle('open', isOpen);
      hamburgerBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    mobileNavPanel.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        hamburgerBtn.classList.remove('open');
        mobileNavPanel.classList.remove('open');
      });
    });
  }

  // promo bar rotating messages
  var promoMsgs = document.querySelectorAll('.promo-msg');
  if(promoMsgs.length > 1){
    var promoIndex = 0;
    setInterval(function(){
      promoMsgs[promoIndex].classList.remove('is-active');
      promoMsgs[promoIndex].classList.add('is-leaving');
      var prevIndex = promoIndex;
      promoIndex = (promoIndex + 1) % promoMsgs.length;
      promoMsgs[promoIndex].classList.add('is-active');
      setTimeout(function(){ promoMsgs[prevIndex].classList.remove('is-leaving'); }, 500);
    }, 3500);
  }

  // carousel arrows
  document.querySelectorAll('.carousel-arrows').forEach(group => {
    const track = group.closest('.section-head').parentElement.querySelector('.carousel-track');
    if(!track) return;
    group.querySelectorAll('.carousel-arrow').forEach(btn => {
      btn.addEventListener('click', () => {
        const dir = parseInt(btn.dataset.dir, 10);
        const cardWidth = track.querySelector('.carousel-item')?.offsetWidth || 280;
        track.scrollBy({ left: dir * (cardWidth + 24) * 2, behavior: 'smooth' });
      });
    });
  });

  // carousel: mouse drag-to-scroll + vertical wheel -> horizontal scroll
  document.querySelectorAll('.carousel-track').forEach(track => {
    // convert vertical wheel movement into horizontal scroll
    track.addEventListener('wheel', (e) => {
      if(Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        track.scrollLeft += e.deltaY;
        e.preventDefault();
      }
    }, { passive: false });

    // click-and-drag scrolling with the mouse
    let isDown = false, startX = 0, startScroll = 0, dragged = false;
    track.addEventListener('mousedown', (e) => {
      isDown = true; dragged = false;
      startX = e.pageX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mouseup', () => { isDown = false; track.classList.remove('is-dragging'); });
    window.addEventListener('mouseleave', () => { isDown = false; track.classList.remove('is-dragging'); });
    track.addEventListener('mousemove', (e) => {
      if(!isDown) return;
      const delta = e.pageX - startX;
      if(Math.abs(delta) > 4) dragged = true;
      track.scrollLeft = startScroll - delta;
    });
    // prevent the drag from also firing a click on links/cards
    track.addEventListener('click', (e) => {
      if(dragged){ e.preventDefault(); e.stopPropagation(); }
    }, true);
  });